import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigateWithScrollMemory } from '../../hooks/useNavigateWithScrollMemory';

// Preserve the existing detail/back navigation contract and normal browser link gestures.
export default function BrowseLink({ to, state, onClick, target, children, ...props }) {
  const navigate = useNavigateWithScrollMemory();
  return (
    <Link
      {...props}
      to={to}
      state={state}
      target={target}
      onClick={(event) => {
        onClick?.(event);
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          (target && target !== '_self')
        )
          return;
        event.preventDefault();
        navigate(to, { state });
      }}
    >
      {children}
    </Link>
  );
}
